import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function initials(name: string) {
  return name
    .split(' ')
    .map((part) => part.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('');
}

export function getInitialsStyle(initials: string) {
  const styles = ['bg-[#2E81DA]', 'bg-[#E3514D]', 'bg-[#5FC360]', 'bg-[#F6BB2D]', 'bg-[#F99226]'];
  if (initials.length && initials !== '?') {
    const alphaBeta = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const i = alphaBeta.indexOf(initials[0].toUpperCase());
    if (i >= 0 && i < alphaBeta.length) {
      return styles[i % styles.length];
    }
    return styles[3];
  }
  return styles[3];
}
